<template>
  <div class="question-loader-w">

    <!-- INPUT QUESTION [INPUT]-->
    <div class="question-w" v-if="question.type === 'INPUT'">
      <div class="main-title">
        <span>{{ question.name }}</span>
        <span v-if="question.required" style="color: red"> *</span>
      </div>
      <div class="input-w">
        <el-input
          @focus="focusOn()"
          v-if="question.inputType === 'NORMAL'"
          placeholder="Input here"
          v-model="question.value">
        </el-input>
        <el-input
          @focus="focusOn()"
          v-if="question.inputType === 'TEXT_AREA'"
          type="textarea"
          placeholder="Input here"
          :autosize="{ minRows: 2, maxRows: 4}"
          v-model="question.value">
        </el-input>
      </div>
    </div>

    <!-- RADIO QUESTION [RADIO]-->
    <div class="question-w" v-if="question.type === 'RADIO'">
      <div class="main-title">
        <span>{{ question.name }}</span>
        <span @click="question.value = ''" class="reset-question-button">Reset</span>
        <span v-if="question.required" style="color: red"> *</span>
      </div>
      <div class="radio-w">
        <el-select
          v-if="question.options.length >= 5 || question.options[0] === '<OTHER>'"
          @focus="focusOn()"
          v-model="question.value"
          filterable
          :allow-create="question.options[0] === '<OTHER>'"
          :placeholder="`Select one ${question.options[0] === '<OTHER>' ? 'or input' : ''}`">
          <el-option
            v-for="item in question.options.filter(item => item !== '<OTHER>')"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
        <!-- Quick Select-->
        <div v-else class="quick-select-tag">
          <div
            v-for="item in question.options.filter(item => item !== '<OTHER>')"
            :key="item"
            :class="item === question.value ? 'selected tag' : 'tag'"
            @click="question.value === item ? question.value = '' : question.value = item"
            >
              {{item}}
          </div>
        </div>
      </div>
    </div>

    <!-- CHECK W/ OPTIONS QUESTION [CKWOP]-->
    <div class="question-w" v-if="question.type === 'CKWOP'">
      <div class="main-title">
        <span>{{ question.name }}</span>
        <span @click="resetCkwop" class="reset-question-button">Reset</span>
        <span v-if="question.required" style="color: red"> *</span>
      </div>
      <div class="check-w" style="margin-left: 4px; margin-bottom: 6px">
        <el-checkbox :value="question.value[0]" @change="changeCkwopMainOption">{{question.label}}</el-checkbox>
      </div>
      <div class="yes-options-w" v-if="question.value[0] && question.yesOptions.length > 0">
        <el-select
          @focus="focusOn()"
          v-model="question.value[1]"
          filterable
          :allow-create="question.yesOptions[0] === '<OTHER>'"
          :placeholder="`Select one ${question.yesOptions[0] === '<OTHER>' ? 'or input' : ''}`">
          <el-option
            v-for="item in question.yesOptions.filter(item => item !== '<OTHER>')"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      </div>
      <div class="no-opetions-w" v-if="!question.value[0] && question.noOptions.length > 0">
        <el-select
          @focus="focusOn()"
          v-model="question.value[1]"
          filterable
          :allow-create="question.noOptions[0] === '<OTHER>'"
          :placeholder="`Select one ${question.noOptions[0] === '<OTHER>' ? 'or input' : ''}`">
          <el-option
            v-for="item in question.noOptions.filter(item => item !== '<OTHER>')"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      </div>
    </div>

    <!-- OPTION W/ OPTION QUESTION [OPWOP]-->
    <div class="question-w" v-if="question.type === 'OPWOP'">
      <div class="main-title">
        <span>{{ question.name }}</span>
        <span @click="resetOpwop" class="reset-question-button">Reset</span>
        <span v-if="question.required" style="color: red"> *</span>
      </div>
      <div class="main-option-w">
        <el-select
          v-if="question.mainOptions.length > 5 || question.mainOptions[0] === '<OTHER>'"
          @focus="focusOn()"
          :value="question.value[0]"
          @change="changeOpwopMainOption"
          :filterable="question.mainOptions.length > 15"
          :allow-create="question.mainOptions[0].id === '<OTHER>'"
          :placeholder="`Select one ${question.mainOptions[0].id === '<OTHER>' ? 'or input' : ''}`">
          <el-option
            v-for="item in question.mainOptions.filter(item => item.display !== '<OTHER>')"
            :key="item.display"
            :label="item.display"
            :value="item.display">
          </el-option>
        </el-select>
        <!-- Quick Select-->
        <div v-else class="quick-select-tag">
          <div
            v-for="item in question.mainOptions.filter(item => item.display !== '<OTHER>')"
            :key="item.display"
            :class="item.display === question.value[0] ? 'selected tag' : 'tag'"
            @click="changeOpwopMainOption(item.display)"
            >
              {{item.display}}
          </div>
        </div>
      </div>
      <div class="secondary-oprion-w" v-if="opwopSecondaryOptions !== null">
        <div class="secondary-question-title">
          {{question.mainOptions.find(item => item.display === question.value[0]).futherName || 'Spec.'}}
        </div>
        <el-select
          v-if="opwopSecondaryOptions.length > 5"
          @focus="focusOn()"
          v-model="question.value[1]"
          :filterable="opwopSecondaryOptions.length > 15 || opwopSecondaryOptions[0] === '<OTHER>'"
          :allow-create="opwopSecondaryOptions[0] === '<OTHER>'"
          :placeholder="`Select one ${opwopSecondaryOptions[0] === '<OTHER>' ? 'or input' : ''}`">
          <el-option
            v-for="item in opwopSecondaryOptions.filter(item => item !== '<OTHER>')"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
        <!-- Quick Select-->
        <div v-if="opwopSecondaryOptions.length <=5 && opwopSecondaryOptions.length > 0" class="quick-select-tag">
          <div
            v-for="item in opwopSecondaryOptions.filter(item => item !== '<OTHER>')"
            :key="item"
            :class="item === question.value[1] ? 'selected tag' : 'tag'"
            @click="question.value[1] = item"
            >
              {{item}}
          </div>
        </div>
        <!-- Input Only-->
        <div v-if="opwopSecondaryOptions.length === 0">
          <el-input
            @focus="focusOn()"
            placeholder="Input here"
            v-model="question.value[1]">
          </el-input>
        </div>
      </div>
    </div>

    <!-- NUMBER WITH OPTION QUESTION [NUMOP]-->
    <div class="question-w" v-if="question.type === 'NUMOP'">
      <div class="main-title">
        <span>{{ question.name }}</span>
        <span v-if="question.required" style="color: red"> *</span>
      </div>
      <div class="numop-w">
        <el-input v-model="question.value[0]" placeholder="Enter Number"  @focus="focusOn()" type="number" pattern="[0-9.]*" inputmode="decimal"></el-input>
        <el-select
          @focus="focusOn()"
          v-if="question.options.length >= 9 || question.options[0] === '<OTHER>'"
          v-model="question.value[1]"
          filterable
          :allow-create="question.options[0] === '<OTHER>'"
          :placeholder="`Select one ${question.options[0] === '<OTHER>' ? 'or input' : ''}`">
          <el-option
            v-for="item in question.options.filter(item => item !== '<OTHER>')"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
        <!--quick select-->
        <div v-else class="quick-select-tag">
          <div
            v-for="item in question.options.filter(item => item !== '<OTHER>')"
            :key="item"
            :class="item === question.value[1] ? 'selected tag' : 'tag'"
            @click="changeSeconedaryOption(item)"
            >
              {{item}}
          </div>
        </div>
      </div>
    </div>

    <!-- OPTION WITH NUMBER QUESTION [OPNUM]-->
    <div class="question-w" v-if="question.type === 'OPNUM'">
      <div class="main-title">
        <span>{{ question.name }}</span>
        <span @click="resetOpnum" class="reset-question-button">Reset</span>
        <span v-if="question.required" style="color: red"> *</span>
      </div>

      <div class="main-option-w">
        <el-select
          v-if="question.mainOptions.length >= 5 || question.mainOptions[0] === '<OTHER>'"
          @focus="focusOn()"
          :value="question.value[0]"
          @change="changeOpnumMainOption"
          :filterable="question.mainOptions.length > 15"
          :allow-create="question.mainOptions[0].id === '<OTHER>'"
          :placeholder="`Select one ${question.mainOptions[0].id === '<OTHER>' ? 'or input' : ''}`">
          <el-option
            v-for="item in question.mainOptions.filter(item => item.id !== '<OTHER>')"
            :key="item.display"
            :label="item.display"
            :value="item.display">
          </el-option>
        </el-select>
        <!-- Quick Select-->
        <div v-else class="quick-select-tag">
          <div
            v-for="item in question.mainOptions.filter(item => item.display !== '<OTHER>')"
            :key="item.display"
            :class="item.display === question.value[0] ? 'selected tag' : 'tag'"
            @click="changeOpnumMainOption(item.display)"
            >
              {{item.display}}
          </div>
        </div>
      </div>

      <div class="number-option" v-if="question.value[0] && question.secondaryOptions[question.mainOptions.find(item => item.display === question.value[0]).id]">
        <div class="secondary-question-title">
          {{question.mainOptions.find(item => item.display === question.value[0]).futherName}}
        </div>
        <el-input v-model="question.value[1]" placeholder="Enter Number"  @focus="focusOn()" type="number" pattern="[0-9.]*" inputmode="decimal"></el-input>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'QuestionLoader',
  model: {
    prop: 'question',
    event: 'change'
  },
  props: ['question'],
  data () {
    return {
      inputError: '',
      opwopSecondaryOptions: null
    }
  },
  watch: {
    question: function () {
      console.log('Question Change =>', this.question)
    }
  },
  methods: {
    focusOn: function () {
      this.inputError = ''
      this.$emit('focused')
    },
    changeSeconedaryOption: function (item) {
      this.question.value[1] = this.question.value[1] === item ? '' : item
      this.$emit('change', this.question)
      this.$forceUpdate()
    },
    changeMainOption: function (item) {
      this.question.value[0] = item
      this.$emit('change', this.question)
      this.$forceUpdate()
    },
    changeCkwopMainOption: function (value) {
      this.question.value[0] = value
      this.question.value[1] = ''

      this.$emit('change', this.question)
      this.$forceUpdate()
    },
    resetCkwop: function () {
      this.question.value[0] = false
      this.question.value[1] = ''
      this.$emit('change', this.question)
      this.$forceUpdate()
    },
    changeOpwopMainOption: function (item) {
      this.question.value[0] = item
      this.question.value[1] = ''
      this.opwopSecondaryOptions = this.calcOpwopSecondaryOptions()
      this.$emit('change', this.question)
      this.$forceUpdate()
    },
    resetOpwop: function () {
      this.question.value[0] = ''
      this.question.value[1] = ''
      this.opwopSecondaryOptions = null
      this.$emit('change', this.question)
      this.$forceUpdate()
    },
    changeOpnumMainOption: function (item) {
      this.question.value[0] = item
      if (this.question.value[0] && this.question.secondaryOptions[this.question.mainOptions.find(item => item.display === this.question.value[0]).id]) {
        this.question.value[1] = '1'
      } else {
        this.question.value[1] = ''
      }
      this.$emit('change', this.question)
      this.$forceUpdate()
    },
    resetOpnum: function () {
      this.question.value[0] = ''
      this.question.value[1] = ''
      this.$emit('change', this.question)
      this.$forceUpdate()
    },
    calcOpwopSecondaryOptions: function () {
      let question = this.question
      let value = question.value[0]
      if (!value) {
        return null
      }
      let secondaryId = (question.mainOptions.find(item => item.display === value)).id
      if (secondaryId === '<OTHER>') {
        return []
      } else {
        return question.secondaryOptions[secondaryId]
      }
    }
  }
}
/*
function mockQuestion(type) {
  const mockQuestions = {
          INPUT: {
            required: true,
              type: 'INPUT',
              inputType: 'NORMAL',
              id: '001',
              name: 'Input Example',
              value: ''
          },
          RADIO: {
            required: true,
            type: 'RADIO',
            id: '002',
            name: 'Radio Example',
            options: ['<OTHER>','Option 1', 'Option 2','Option 3'],
            value: 'Option 1'
          },
          CKWOP: {
            required: true,
            type: 'CKWOP',
            id: '003',
            name: 'Check with option Example',
            yesOptions: ['<OTHER>','Option 1', 'Option 2','Option 3'],
            noOptions: [],
            value: ['NO', '']
          },
          OPWOP: {
            required: true,
            type: 'OPWOP',
            id: '004',
            name: 'Option with option Example',
            mainOptions: [
              {id: '<OTHER>',display: null,futherName: null},
              {id: 'main_1',display: 'MAIN 1',futherName: 'Second 1 options'},
              {id: 'main_2',display: 'MAIN 2',futherName: 'Second 2 options'},
              {id: 'main_3',display: 'MAIN 3',futherName: 'Second 3 options'}
            ],
            secondaryOptions: {
              main_1: ['<OTHER>','Option 1', 'Option 2','Option 3'],
              main_2: ['<OTHER>','Option 1', 'Option 2','Option 3'],
              main_3: ['<OTHER>','Option 1', 'Option 2','Option 3']
            },
            value: ['MAIN 1', 'Option 1']
          },
          NUMBER: {
            required: true,
            type: 'NUMBER',
            id: '005',
            name: 'Number Example',
            value: '0'
          }
        }
    return mockQuestions[type]
}
*/
</script>

<style scoped>
.reset-question-button {
  margin-left: 16px;
  cursor: pointer;
  color: #1e88e5;
}

.numop-w {
  display: flex;
  flex-direction: column;
}
.main-title {
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 4px;
  margin-left: 4px;
  margin-top: 12px;
}

.quick-select-tag {
  margin-top: 12px;
}

.tag {
  display: inline-block;
  cursor: pointer;
  /* height: 32px; */
  font-size: 14px;
  padding: 10px 15px;
  line-height: 16px;
  border-radius: 20px;
  color: #1e88e5;
  font-weight: bold;
  border: solid 1px #1e88e5;
  margin: 6px;
  box-sizing: border-box;
  vertical-align: middle;
  transition: all 0.3s ease
}

.selected {
  background-color: #1e88e5;
  color: #ffffff;
}

.yes-options-w {
  margin-top: 8px;
}
</style>
